import { CollectionWithCursor, FavoritesData, WatchHistory } from '@inplayer-org/inplayer.js';

export type Profile = {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
};

export type Token = {
  jwt: string;
  refreshToken: string;
};

type UserToken = {
  idToken: string;
  refreshToken: string;
  emailId: string;
};

interface UserData {
  profile: {
    profile: {
      uId: string;
      uFullName: string;
      firstname: string;
      lastname?: string;
      uAvatarUrl?: string;
      uRole?: {
        rRole: string;
      };
    };
  };
  emailId?: string;
}

interface Metadata {
  consents: string;
}

interface UserProfile {
  id: string;
  email: string;
  fullName: string;
  firstName: string;
  lastName: string;
  metadata: Metadata;
  regDate: string;
  country: string;
  lastUserIp: string;
  uAvatarUrl?: string;
  role?: string;
}

interface Auth {
  jwt: string;
  refreshToken: string;
}

interface ResponseData {
  auth: Auth;
  user: UserProfile;
  customerConsents: any[];
}

export interface WatchHistoryData {
  media_id: string;
  created_at: number;
  progress?: number;
  updated_at?: number;
}

export const getUserProfileData = (user: UserToken, userData: UserData): ResponseData => {
  const jwt = user.idToken || '';
  const refreshToken = user.refreshToken || '';
  const id = userData?.profile?.profile?.uId || '';
  const email = user?.emailId || localStorage.getItem('userEmail') || '';
  const fullName = userData?.profile?.profile?.uFullName || '';
  const firstName = userData?.profile?.profile?.firstname || '';
  const lastName = userData?.profile?.profile?.lastname || '';
  const uAvatarUrl = userData?.profile?.profile?.uAvatarUrl || '';
  const metadata: Metadata = {
    consents: '[]',
  };
  const regDate = '';
  const country = '';
  const lastUserIp = '';

  return {
    auth: {
      jwt,
      refreshToken,
    },
    user: {
      id,
      email,
      fullName,
      firstName,
      lastName,
      metadata,
      regDate,
      country,
      lastUserIp,
      uAvatarUrl,
      role: userData?.profile?.profile?.uRole?.rRole || '',
    },
    customerConsents: [],
  };
};

export const getFavouriteResponse = (response: any): CollectionWithCursor<FavoritesData> => {
  const collection =
    response?.collection?.map((item: any) => ({
      media_id: item.media_id,
      created_at: item.created_at,
    })) || [];
  const cursor = response?.cursor || null;
  return {
    collection,
    cursor,
  };
};

export const getWatchHistoryResponse = (response: any): CollectionWithCursor<WatchHistory> => {
  const collection =
    response?.collection?.map((item: any) => ({
      media_id: item.media_id,
      created_at: item.created_at,
      progress: item.progress,
      updated_at: item.updated_at,
    })) || [];
  const cursor = response?.cursor || null;
  return {
    collection,
    cursor,
  };
};
